import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const MobileDevelopment = () => {
  useEffect(() => {
    // Scroll-based navigation highlighting
    const sections = document.querySelectorAll(".tab-data[id]");
    const navLinks = document.querySelectorAll(".nav-selector a");

    const navHighlighter = () => {
      let scrollY = window.pageYOffset;

      sections.forEach((current) => {
        const sectionHeight = current.offsetHeight;
        const sectionTop =
          current.getBoundingClientRect().top + window.pageYOffset - 50;
        const sectionId = current.getAttribute("id");

        if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
          navLinks.forEach((link) => {
            link.parentElement.classList.remove("active");
            if (link.getAttribute("href") === `#${sectionId}`) {
              link.parentElement.classList.add("active");
            }
          });
        }
      });
    };

    window.addEventListener("scroll", navHighlighter);
    return () => window.removeEventListener("scroll", navHighlighter);
  }, []);

  return (
    <div className="mobile-development-page">
      <section className="banner-section">
        <div className="intro">
          <div className="intro-bg wow fadeIn" data-wow-delay="0.5s">
            <img
              src="/assets/images/background/intro-bg.jpg"
              alt="Light Background"
            />
          </div>
          <div className="container">
            <h1 className="wow fadeInUp" data-wow-delay="0.5s">
              Mobile Development
            </h1>
          </div>
        </div>
      </section>

      <section className="top-services-section">
        <div className="container">
          <div className="title">
            <h2 className="wow fadeInUp">
              Deliver a{" "}
              <span className="gradient-text">
                seamless, impactful experience
              </span>{" "}
              across all devices
            </h2>
            <h3 className="wow fadeInUp">How we work</h3>
            <p className="wow fadeInUp">
              At Slash Star, we are your trusted partners in mobile app
              development. From ideation to deployment, we work closely with you
              to bring your app vision to life. Our team of experts provides
              end-to-end solutions that include validating your idea, creating a
              seamless user experience, and maintaining a robust infrastructure
              in the public cloud. Mobile App development services are known as
              the best choice for building secure, scalable digital solutions.
              Our dedicated app developers ensure that your apps make you
              future-forward businesses.
            </p>
          </div>

          <div className="row flex-start wow fadeInUp">
            <div className="col col-4">
              <div className="box">
                <span>01</span>
                <h3>Project ideation</h3>
                <p>
                  We work closely with you to understand your app idea, its
                  objectives, target audience and define project goals and
                  requirements.
                </p>
              </div>
            </div>
            <div className="col col-4">
              <div className="box">
                <span>02</span>
                <h3>Planning</h3>
                <p>
                  We create a detailed project roadmap, including timelines,
                  milestones, and budgets, to ensure timely and cost-effective
                  delivery.
                </p>
              </div>
            </div>
            <div className="col col-4">
              <div className="box">
                <span>03</span>
                <h3>Development</h3>
                <p>
                  Our team of expert developers builds a scalable, secure, and
                  high-performance app using the latest technology and suitable
                  methodology.
                </p>
              </div>
            </div>
            <div className="col col-4">
              <div className="box">
                <span>04</span>
                <h3>Testing and QA</h3>
                <p>
                  We conduct rigorous testing to ensure that the app meets all
                  functional and non-functional requirements and provides a
                  seamless user experience.
                </p>
              </div>
            </div>
            <div className="col col-4">
              <div className="box">
                <span>05</span>
                <h3>Deployment</h3>
                <p>
                  We deploy the app to the app stores and make it available to
                  your users, ensuring that it meets all app store guidelines
                  and standards.
                </p>
              </div>
            </div>
            <div className="col col-4">
              <div className="box">
                <span>06</span>
                <h3>Support and maintenance</h3>
                <p>
                  We provide ongoing support and maintenance to keep the app
                  up-to-date, secure, and bug-free, ensuring a great user
                  experience.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="tabs-section">
        <div className="container wow fadeInUp">
          <div className="row">
            <div className="col col-6 nav-selector">
              <div className="title-small">
                <span>SERVICES</span>
              </div>
              <ul>
                <li>
                  <a href="#section1">Android Development</a>
                </li>
                <li>
                  <a href="#section2">iOS Development</a>
                </li>
                <li>
                  <a href="#section3">Flutter Development</a>
                </li>
                <li>
                  <a href="#section4">React Native Development</a>
                </li>
              </ul>
            </div>
            <div className="col col-6">
              <div className="tab-data" id="section1">
                <div className="tab-image">
                  <img
                    src="/assets/images/navbar/mobile/mobile-android.png"
                    alt="android"
                  />
                </div>
                <h3>Android Development</h3>
                <p>
                  If you need an Android development company with a strong
                  portfolio, consider Slash Star. We've developed thousands of
                  custom Android apps for startups, enterprises, and leading
                  brands worldwide.
                </p>
                <p>
                  Our Android development team has expertise in creating
                  scalable, visually appealing apps for mobile and tablet
                  devices.
                </p>
                <p>
                  From design and Mobile App development Company to testing and
                  support, our team of mobile app experts employs the latest
                  technologies and design features to create best-in-class apps
                  for the Android operating system.
                </p>
              </div>
              <div className="tab-data" id="section2">
                <div className="tab-image">
                  <img
                    src="/assets/images/navbar/mobile/mobile-ios.png"
                    alt="ios"
                  />
                </div>
                <h3>iOS Development</h3>
                <p>
                  iOS development services guidelines related to all individual
                  platforms - iPad, iPhone, Apple TV, and Apple Watch.
                </p>
                <p>
                  We are a Web App development Agency with a dedicated team of
                  app developers that provide custom iPhone application
                  development services keeping in specific design.
                </p>
              </div>
              <div className="tab-data" id="section3">
                <div className="tab-image">
                  <img
                    src="/assets/images/navbar/mobile/mobile-flutter.png"
                    alt="flutter"
                  />
                </div>
                <h3>Flutter Development</h3>
                <p>
                  We also specialize in building cross-platform apps that are
                  optimized for performance and user experience, ensuring that
                  your app meets your business needs and exceeds your
                  expectations.
                </p>
                <p>
                  Use Flutter and experience the benefits of cross-platform
                  native-like mobile apps for your business. Hire Slash Star for
                  flutter development services.
                </p>
              </div>
              <div className="tab-data" id="section4">
                <div className="tab-image">
                  <img
                    src="/assets/images/navbar/mobile/mobile-react.png"
                    alt="react"
                  />
                </div>
                <h3>React Native Development</h3>
                <p>
                  Our team of experts specializes in offering advanced React
                  Native development services that create compatible,
                  cross-platform and custom configurable apps.
                </p>
                <p>
                  From designing to developing and launching your app, our team
                  is dedicated to providing exceptional service and ensuring
                  that your app meets your business goals.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="technology-section">
        <div className="container wow fadeInUp">
          <div className="title-small">
            <span>Technology</span>
          </div>
          <div className="title">
            <h2>
              Empowering Your Business with <br />
              Our <span className="gradient-text">Tech Savvy Stack</span>
            </h2>
          </div>
          <div className="flex-start">
            <div className="col">
              <i>
                <img src="/assets/images/icon/icon-android.svg" alt="android" />
              </i>
              <span>Android</span>
            </div>
            <div className="col">
              <i>
                <img
                  src="/assets/images/icon/icon-ios-color.svg"
                  alt="ios-color"
                />
              </i>
              <span>iOS</span>
            </div>
            <div className="col">
              <i>
                <img src="/assets/images/icon/icon-flutter.svg" alt="flutter" />
              </i>
              <span>Flutter</span>
            </div>
            <div className="col">
              <i>
                <img src="/assets/images/icon/icon-react.svg" alt="react" />
              </i>
              <span>React Native</span>
            </div>
            <div className="col">
              <i>
                <img src="/assets/images/icon/icon-kotlin.svg" alt="kotlin" />
              </i>
              <span>Kotlin</span>
            </div>
            <div className="col">
              <i>
                <img src="/assets/images/icon/icon-dart.svg" alt="dart" />
              </i>
              <span>Dart</span>
            </div>
            <div className="col">
              <i>
                <img src="/assets/images/icon/icon-swift.svg" alt="swift" />
              </i>
              <span>Swift</span>
            </div>
            <div className="col">
              <i>
                <img src="/assets/images/icon/icon-java.svg" alt="java" />
              </i>
              <span>Java</span>
            </div>
            <div className="col">
              <i>
                <img
                  src="/assets/images/icon/icon-flutter-flow.svg"
                  alt="flutter-flow"
                />
              </i>
              <span>Flutter Flow</span>
            </div>
            <div className="col">
              <i>
                <img
                  src="/assets/images/icon/icon-javascript.svg"
                  alt="javascript"
                />
              </i>
              <span>Javascript</span>
            </div>
          </div>
        </div>
      </section>

      <section className="approach-section">
        <div className="container wow fadeInUp">
          <div className="title-small">
            <span>Why Us</span>
          </div>
          <div className="title">
            <h2>
              The Benefits of <span className="gradient-text">Partnering</span>{" "}
              with Us
            </h2>
          </div>
          {/* Desktop */}
          <div className="why-us-content why-us-desktop wow fadeInUp">
            <div className="why-us-datas">
              <div>
                <h3>Highly-skilled developers</h3>
                <p>
                  Our experienced developers create high-quality, scalable apps
                  that meet your business needs and use the latest technologies
                  to stay competitive in the marketplace.
                </p>
              </div>
              <div>
                <h3>Agile project management</h3>
                <p>
                  We use an agile approach to work collaboratively with our
                  clients, adapt to changing requirements, and deliver your app
                  on time and within budget.
                </p>
              </div>
              <div>
                <h3>Fast communication</h3>
                <p>
                  We provide fast communication and updates to keep you informed
                  and involved throughout the development process.
                </p>
              </div>
            </div>
            <div className="why-us-datas">
              <div>
                <h3>Modern technologies</h3>
                <p>
                  We use the latest technologies and development practices to
                  create apps that are optimized for performance, user
                  experience, and security.
                </p>
              </div>
              <div>
                <h3>High security</h3>
                <p>
                  We follow industry-standard security practices and protocols
                  to ensure that your app is secure and protected against cyber
                  threats.
                </p>
              </div>
            </div>

            <div className="why-us-datas">
              <div>
                <h3>Robust security</h3>
                <p>
                  We ensure compliance with leading security standards,
                  including NIST CSF, ISO 27001, HIPAA, and GDPR, to keep your
                  data and your users' data safe and secure.
                </p>
              </div>
            </div>
          </div>
          {/* Mobile */}
          <div className="why-us-content why-us-mobile wow fadeInUp">
            <div>
              <h3>Highly-skilled developers</h3>
              <p>
                Our experienced developers create high-quality, scalable apps
                that meet your business needs and use the latest technologies to
                stay competitive in the marketplace.
              </p>
            </div>
            <div>
              <h3>Agile project management</h3>
              <p>
                We use an agile approach to work collaboratively with our
                clients, adapt to changing requirements, and deliver your app on
                time and within budget.
              </p>
            </div>
            <div>
              <h3>Fast communication</h3>
              <p>
                We provide fast communication and updates to keep you informed
                and involved throughout the development process.
              </p>
            </div>
            <div>
              <h3>Modern technologies</h3>
              <p>
                We use the latest technologies and development practices to
                create apps that are optimized for performance, user experience,
                and security.
              </p>
            </div>
            <div>
              <h3>High security</h3>
              <p>
                We follow industry-standard security practices and protocols to
                ensure that your app is secure and protected against cyber
                threats.
              </p>
            </div>
            <div>
              <h3>Robust security</h3>
              <p>
                We ensure compliance with leading security standards, including
                NIST CSF, ISO 27001, HIPAA, and GDPR, to keep your data and your
                users' data safe and secure.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="portfolio-section projects-section">
        <div className="container">
          <h2>More Projects</h2>
          <div className="portfolio card-deck-js">
            <div className="portfolio-card">
              <Link to="/finutss">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img
                      src="/assets/images/protfolio/finutz.svg"
                      alt="Finutss"
                    />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Finutss</h3>
                      <div>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow-1" />
                    </div>
                  </div>
                </div>
              </Link>
              <Link to="/bullz">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img src="/assets/images/protfolio/bullz.svg" alt="bullz" />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Bullz</h3>
                      <div>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="" />
                    </div>
                  </div>
                </div>
              </Link>
              <Link to="/telly">
                <div className="portfolio-product">
                  <div className="product-image">
                    <img src="/assets/images/protfolio/telly.svg" alt="Telly" />
                  </div>
                  <div className="product-content">
                    <div className="product-data">
                      <h3>Telly</h3>
                      <div>
                        <span>Web</span>
                        <span>iOS</span>
                        <span>Android</span>
                      </div>
                    </div>
                    <div className="product-url">
                      <img src="/assets/images/icon/arrow.svg" alt="arrow-2" />
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MobileDevelopment;
